"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChartContext_1 = require("../../context/ChartContext");
const ScaleContext_1 = require("../../context/ScaleContext");
const highlight_1 = require("../../highlight");
function BaseLineZones() {
    const { toolOptions: { selectedTool, data: { baselineCorrection }, }, } = (0, ChartContext_1.useChartData)();
    const baseLineZones = baselineCorrection.zones;
    if (selectedTool !== 'baselineCorrection' || baseLineZones.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("g", { children: baselineCorrection.zones.map((zone) => ((0, jsx_runtime_1.jsx)(BaseLineZone, { ...zone }, zone.id))) }));
}
function BaseLineZone(props) {
    const { from, to, id } = props;
    const { onHover, isActive, defaultActiveStyle: { backgroundColor: activeFill }, } = (0, highlight_1.useHighlight)([id], { type: 'BASELINE_ZONE', extra: { id } });
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const x = scaleX()(to);
    const width = scaleX()(from) - scaleX()(to);
    return ((0, jsx_runtime_1.jsx)("g", { transform: `translate(${x},0)`, ...onHover, children: (0, jsx_runtime_1.jsx)("rect", { x: "0", width: width, height: "100%", style: { backgroundColor: 'red' }, fill: isActive ? activeFill : '#b8b8b857' }) }));
}
exports.default = BaseLineZones;
